import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { Circle, CircleDot, CheckCircle2 } from 'lucide-react';
import type { AgendaItemProps } from '@shared/widget-schemas';
import { capitalizeFirst } from './textFormat';

const statusConfig = {
  pending: { icon: Circle, color: 'text-muted-foreground' },
  active: { icon: CircleDot, color: 'text-blue-600' },
  completed: { icon: CheckCircle2, color: 'text-emerald-600' },
} as const;

export function AgendaItemWidget({ title, description, status }: AgendaItemProps) {
  const { icon: StatusIcon, color } = statusConfig[status];

  return (
    <Card className="w-full">
      <CardContent className="p-4 flex items-start gap-3">
        <StatusIcon className={cn('h-5 w-5 mt-0.5 shrink-0', color)} />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">{capitalizeFirst(title)}</p>
          {description && (
            <p className="text-xs text-muted-foreground mt-0.5">{capitalizeFirst(description)}</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
